import { AutoMap } from '@automapper/classes';
import { EZoneType } from '../../domain/enums/zone-type';

export class ZoneEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    Position!: number;
    @AutoMap()
    Description?: string;
    @AutoMap()
    CustomerReference?: string;
    @AutoMap()
    Type!: EZoneType;
    @AutoMap()
    Usage!: number;
    @AutoMap()
    BuildingType!: number;
    @AutoMap()
    BuildingTypeNonStandard?: string;
    @AutoMap()
    RoomUsage!: number;
    @AutoMap()
    RoomUsageNonStandard?: string;
    @AutoMap()
    OnSiteProtectionAndSealingType?: string;
    @AutoMap()
    ActivitySimulation?: number;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    IsDepose!: boolean;
    MPCAIds?: number[];
    MeasureIds?: number[];
    AreaMapIds?: number[];
}
